/*
* TODO
*  Add to cart
*  Add to cart from item page
*  Remove from cart
*  Apply Points to cart
*  Apply Discount to cart
*  Change quantity on cart
*  Ask question
*  Answer question
*  Item image + video slider
*  Add review
*/

let cancelToken;

// region Stock reminder
$(document).on('click', '.js-stock-reminder', function (event) {
    event.preventDefault();
    axios({
        method: 'get',
        url: $(this).closest('form').attr('action'),
        responseType: 'json',
    }).then((response) => {
        if (response.data.success) {
            location.reload();
            modalHandleResponse(response.data);
        }
        modalHandleMessage(response.data.message.value);
    }).catch((error) => {
        console.error(error)
    });

});
// endregion

// region Add to cart
$(document).on('click', '.js-add-to-cart', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let $checkoutTab = $(this).closest('.store-listing').find('.js-store-checkout-tab');

    axios({
        method: 'post',
        url: $(this).closest('form').attr('action'),
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        if (response.data.success) {
            $checkoutTab.addClass('is-active');

            setTimeout(() => {
                $checkoutTab.removeClass('is-active');
            }, 5000);
        } else if (response.data.hasOwnProperty('redirect')) {
            window.location.href = response.data.redirect;
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Add to cart from item page
window.modal_callbacks.addToCartSuccess = function (response) {
    if (response.success) {
        $('.js-cart-options')[0].reset();
        $('.js-item-size-wrapper').addClass('hide');
        $('.js-item-colour').removeAttr('checked');
        $('.js-item-size').removeAttr('checked');

        $('.js-store-checkout-tab-container').html(response.addToCartSuccess);

        setTimeout(() => {
            $('.js-store-checkout-tab').removeClass('is-active');
            $('.js-store-checkout-tab-container').html('');
        }, 5000);
    }
}

$(document).on('click', '.js-add-to-cart-options', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let $cartOptions = $('.js-cart-options');

    $cartOptions.find('.alert').remove();

    let $colour = $('.js-cart-options input[name="product_colour"]:checked');
    let $size = $('.js-cart-options input[name="product_size"]:checked');
    let $price = $('.js-cart-options input[name="product_price"]:checked');

    if ($('.js-cart-options input[name="product_colour"]').length > 0 && $colour.val() === undefined) {
        $cartOptions.prepend('<div class="alert alert-danger">Please select a colour</div>');
        return;
    }

    if ($('.js-cart-options input[name="product_size"]').length > 0 && $size.val() === undefined) {
        $cartOptions.prepend('<div class="alert alert-danger">Please select a size</div>');
        return;
    }

    axios({
        method: 'post',
        url: $(this).attr('data-action'),
        data: {
            quantity: parseInt($('.js-cart-options #quantity').val(), 10),
            colour: $colour.val(),
            size: $size.val(),
            price: $price.val(),
        },
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        modalHandleResponse(response.data);
    }).catch((error) => {
        console.error(error)
    });
});

$(document).on('click', '.js-add-to-cart-customise', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let $cartOptions = $('.js-cart-options');

    $cartOptions.find('.alert').remove();

    let $colour = $('.js-cart-options input[name="product_colour"]:checked');
    let $size = $('.js-cart-options input[name="product_size"]:checked');

    if ($('.js-cart-options input[name="product_colour"]').length > 0 && $colour.val() === undefined) {
        $cartOptions.prepend('<div class="alert alert-danger">Please select a colour</div>');
        return;
    }

    if ($('.js-cart-options input[name="product_size"]').length > 0 && $size.val() === undefined) {
        $cartOptions.prepend('<div class="alert alert-danger">Please select a size</div>');
        return;
    }

    axios({
        method: 'post',
        url: $(this).attr('data-action'),
        data: {
            quantity: parseInt($('.js-cart-options #quantity').val(), 10),
            colour: $colour.val(),
            size: $size.val(),
        },
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        $('.js-modals-container').html(response.data.modal);

        $('#customisation_modal').ready(function () {
            $('#customisation_modal').modal({backdrop: 'static'});
        });
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Change quantity on cart
$(document).on('click', '.js-ins-change', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    let type = $(this).attr('data-type');
    let $wrapper = $(this).closest('.js-input-number-selector');

    let url = $wrapper.attr('data-url');

    if (url === '#') {
        let $input = $wrapper.find('input');
        let value = parseInt($input.val(), 10);
        value = type === 'increase' ? (value + 1) : (value - 1);

        $wrapper.find('input').val(value);

        if (value === 1) {
            $wrapper.find('.js-ins-change[data-type="decrease"]').attr('disabled', true);
        } else {
            $wrapper.find('.js-ins-change[data-type="decrease"]').removeAttr('disabled');
        }

        return;
    }

    $wrapper.find('button, input').attr('disabled', true);

    axios({
        method: 'post',
        url: $wrapper.attr('data-url'),
        responseType: 'json',
        cancelToken: cancelToken.token,
        data: {type: type},
    }).then((response) => {
        modalHandleResponse(response.data);
        if (response.data.success) {
            $wrapper.find('button, input').attr('disabled', false);
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Remove from cart
$(document).on('click', '.js-cart-remove', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $(this).attr('data-url'),
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        if (response.data.success) {
            $.each(response.data.replace, (selector, content) => {
                $(selector).html(content)
            });
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Apply points to cart
$(document).on('click', '.js-cart-apply-points', function (event) {
    event.preventDefault();


    let $formGroup = $(this).closest('form').find('.form-group');
    let type = $(this).attr('data-type');
    let points = parseInt($('#points').val(), 10);

    if (points < 1 && type === 'apply') {
        return;
    }

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $(this).closest('form').attr('action'),
        data: {points: points, type: type},
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        $('.js-error-block-points').remove();
        if (response.data.success) {
            $.each(response.data.replace, (selector, content) => {
                $(selector).html(content)
            });
        } else {
            $formGroup.removeClass('has-success');
            $formGroup.addClass('has-error');
            $formGroup.append(`<p class="help-block js-error-block-points"><strong>${response.data.message}</strong></p>`);
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Apply discount to cart
$(document).on('click', '.js-cart-apply-discount', function (event) {
    event.preventDefault();

    let $formGroup = $(this).closest('form').find('.form-group');

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $(this).closest('form').attr('action'),
        data: {discount_code: $('#discount_code').val()},
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        $('.js-error-block-discount').remove();
        if (response.data.success) {
            $.each(response.data.replace, (selector, content) => {
                $(selector).html(content)
            });
        } else {
            $formGroup.removeClass('has-success');
            $formGroup.addClass('has-error');
            $formGroup.append(`<p class="help-block js-error-block-discount"><strong>${response.data.message}</strong></p>`);
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Item Page Slider
$(document).ready(function () {
    let $itemSlider = $('.js-item-slider');
    let $linkedItemSlider = $('.js-linked-item-slider');
    if ($itemSlider.length > 0) {
        let $mainItemSlider = $('.slider-for');
        let $subItemSlider = $('.slider-nav');

        $mainItemSlider.slick({
            lazyLoad: 'progressive',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.slider-nav',
        }).slick('slickFilter', function (index, $elem) {
            return $($elem).find('.slider-main').attr('data-colour') === $itemSlider.attr('data-colour');
        });
        $subItemSlider.slick({
            lazyLoad: 'progressive',
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            arrows: true,
            centerMode: false,
            focusOnSelect: true,
            infinite: true
        }).slick('slickFilter', function (index, $elem) {
            return $($elem).find('.slider-preview').attr('data-colour') === $itemSlider.attr('data-colour');
        });

        $mainItemSlider.on('afterChange', function (event, slick, direction) {
            $('.slider-counter').html(`(${(slick.currentSlide + 1)}/${slick.slideCount})`);
        })

        $(document).on('change', '.js-product-colour input', function () {
            let colour = $(this).attr('data-value').trim();

            $mainItemSlider.slick('slickUnfilter').slick('slickFilter', function (index, $elem) {
                return $($elem).find('.slider-main').attr('data-colour') === colour;
            }).slick('slickGoTo', 0);
            $subItemSlider.slick('slickUnfilter').slick('slickFilter', function (index, $elem) {
                return $($elem).find('.slider-preview').attr('data-colour') === colour;
            }).slick('slickGoTo', 0);
        });
    }

    if ($linkedItemSlider.length > 0) {
        let $cart = $('.similar-products-js');
        $linkedItemSlider.slick({
            slidesToShow: $cart.length > 0 ? 4 : 3,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
        });
    }
});
// endregion

// region Item Page Styles
function changeProductStyle() {
    let $size = $('.js-product-size');
    let $colour = $('.js-product-colour');
    let size = $size.find('input:checked').attr('data-value');
    let colour = $colour.find('input:checked').attr('data-value');

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    $('.js-product-colour-label').html($('.js-product-colour input:checked').next().text());
    $('.js-product-size-label').html($('.js-product-size input:checked').next().text());

    axios({
        method: 'post',
        url: $('.js-product').attr('data-url'),
        data: {size: size, colour: colour},
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        if (response.data.success) {
            let $list = '';
            $.each(response.data.sizes, function (i, data) {
                $list += `<input type="radio" name="product_size" id="${data.uid}" value="${data.uid}" data-value="${data.key}" ${data.key === size ? 'checked' : ''}>
                    <label for="${data.uid}"><span>${data.name}</span></label>`;
            });

            $('.js-product-size-values').html($list);

            $list = '';
            $.each(response.data.colours, function (i, data) {
                $list += `<input type="radio" name="product_colour" id="${data.uid}" value="${data.uid}" data-value="${data.key}" ${data.key === colour ? 'checked' : ''}>
                    <label for="${data.uid}"><span style="background-color: ${data.hex}">${data.name}</span></label>`;
            });

            $('.js-product-colour-values').html($list);
        }
    }).catch((error) => {
        console.error(error)
    });
}

$(document).on('change', '.js-product-size', changeProductStyle);
$(document).on('change', '.js-product-colour', changeProductStyle);
$(document).on('change', '.js-product-price input', function () {
    $('.js-price').html($(this).attr('data-label'));
});
// endregion

// region Toggle Wishlist
$(document).on('click', '.js-item-toggle-wishlist', function (event) {
    event.preventDefault();

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $(this).attr('href'),
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        if (response.data.success) {
            $(this).find('i')[0].classList = response.data.icon;
            $(this).find('span').html(response.data.button);
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Category Filters
$(document).on('click', '.js-product-filters a[data-filter]', function (event) {
    event.preventDefault();

    let filter = $(this).attr('data-filter');

    // region Change active item
    $(`.js-product-filters a[data-filter="${filter}"][data-selected="true"]`)
        .attr('data-selected', 'false')
        .parent().removeClass('active');

    $(this).attr('data-selected', 'true').parent().addClass('active');

    $(this).closest('.js-dropdown').find('.js-filter-label').html($(this).html());
    // endregion

    let selected = $('.js-product-filters a[data-filter][data-selected="true"]');

    let query = {};

    let $category = $('.js-product-filters input[name="category"]');
    if ($category.val() !== '') {
        query['category'] = $category.val();
    }

    $.each(selected, function () {
        if ($(this).attr('data-type').trim() === '') {
            return;
        }
        query[$(this).attr('data-filter')] = $(this).attr('data-type');
    });

    // region Update Nav
    let params = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    window.history.pushState(query, document.title, '?' + params);
    // endregion

    if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }

    cancelToken = axios.CancelToken.source();

    axios({
        method: 'post',
        url: $('.js-product-filters').attr('data-url'),
        data: query,
        responseType: 'json',
        cancelToken: cancelToken.token,
    }).then((response) => {
        if (response.data.success) {
            $('.js-category-items').html(response.data.html);

            $('.js-cart-sub-category').removeClass('highlight');
            if (query.hasOwnProperty('category') && query.category !== '') {
                $(`.js-cart-sub-category[data-category="${query.category}"]`).addClass('highlight');
            }
        }
    }).catch((error) => {
        console.error(error)
    });
});
// endregion

// region Checkout > Address Select
$(document).on('change', '.js-address-list input[type="radio"]', function () {
    $(this).closest('.js-address-list').find('li').removeClass('selected');
    $(this).closest('li').addClass('selected');
});
// endregion

// region Checkout > Toggle
$(document).on('click', '.js-toggle-display', function (event) {
    event.preventDefault();

    let $icon = $(this).find('i');
    if ($icon.attr('data-original') === undefined) {
        $icon.attr('data-original', $icon.attr('class'));
        $icon.attr('class', $icon.attr('data-swap'));
    } else {
        $icon.attr('class', $icon.attr('data-original'));
        $icon.removeAttr('data-original');
    }

    let $label = $(this).find('span');
    if ($label.attr('data-original') === undefined) {
        $label.attr('data-original', $label.text().trim());
        $label.html($label.attr('data-swap'));
    } else {
        $label.html($label.attr('data-original'));
        $label.removeAttr('data-original');
    }

    let $target = $($(this).attr('data-bs-target'));

    if ($target.attr('aria-expanded') === 'true') {
        $target.attr('aria-expanded', 'false');
        $target.addClass('hide');
    } else {
        $target.attr('aria-expanded', 'true');
        $target.removeClass('hide');
    }
})
// endregion

// region PayPal Cart
$(document).ready(function () {

    if ($('#paypal-buttons').length > 0) {

        var elem = document.getElementById('paypal-buttons');

        window.paypalLoadScript({
            "client-id": elem.getAttribute('data-pk').toString(),
            currency: "GBP"

        }).then((paypal) => {
            paypal.Buttons({
                // Set up the transaction
                createOrder: function (data, actions) {
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                                value: elem.getAttribute('data-value').toString()
                            }
                        }]
                    });
                },
                // Finalize the transaction
                onApprove: function (data, actions) {

                    return actions.order.capture().then(function (orderData) {
                        // Successful capture! For demo purposes:
                        console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));

                        var transaction = orderData.purchase_units[0].payments.captures[0];
                        // alert('Transaction ' + transaction.status + ': ' + transaction.id + '\n\nSee console for all available details');
                        actions.redirect($('.js-payment-confirm').attr('data-url') + '?payment_intent=' + transaction.id);


                        // Replace the above to show a success message within this page, e.g.
                        // const element = document.getElementById('paypal-button-container');
                        // element.innerHTML = '';
                        // element.innerHTML = '<h3>Thank you for your payment!</h3>';
                        // Or go to another URL:  actions.redirect('thank_you.html');
                    });
                },


                onError: function (err) {
                    // For example, redirect to a specific error page
                    // window.location.href = "/your-error-page-here";
                    history.go(-1);

                    let message = document.querySelector("#error-message");
                    message.classList.remove("hidden");
                    message.text = err.message;

                },


            }).render('#paypal-buttons');
        });

    }
});
// endregion

// region Product Comparison
if ($('.compare-check').length) {

    $(document).ready(function () {
        checkboxState();
        compare(false);
    });

    function checkboxState() {
        let $checked = $('.compare-check:checked').length;
        let $notChecked = $('.compare-check:not(:checked)');

        if ($checked === 4) {
            $notChecked.attr('disabled', 'disabled');
        } else {
            $notChecked.removeAttr('disabled');
        }
    }

    function compare(store = true) {
        let $checked = $('.compare-check:checked');
        let $compareTool = $('.sticky-compare');
        let $compareContainer = $('.stick-w');
        let categoryName = $('.store-list-container').attr('data-category');
        let checkCount = $checked.length;
        let productString = '';
        let html = '';

        if (checkCount < 5) {
            $($checked).each(function (i, checkbox) {
                let model = checkbox.id.replace('compare_', '');
                productString += model + ',';
                let image = $(checkbox).closest('.store-listing').find('.__image img').attr('src');
                if(image === '') {
                    image = 'https://via.placeholder.com/50x50';
                }
                html += `<div class="compare-p"><div class="img-block"><img src="${image}" alt="" style="max-width: 50px; max-height: 50px"> <p>${model}</p></div><span class="comparebar-thumb-close js-comparebar-thumb-close" data-id="${model}"><i class="icon icon-close"></i></span><div class="vl"></div></div>`;
            });

            productString = productString.replace(/,\s*$/, "");
            let url = $compareTool.attr('data-url') + '/' + categoryName + '?products=' + productString;
            if(checkCount === 1) {
                html += `<div class="compare-b"><a href="${url}" class="btn btn-primary disabled">Add 1 more to compare</a></div>`;
            } else {
                html += `<div class="compare-b"><a href="${url}" class="btn btn-primary">Click here to compare ${checkCount} products</a></div>`;
            }

            $compareContainer.html(html);
            // save in session
            if (store) {
                axios.post($compareTool.attr('data-store'), {
                    products: productString,
                    category: categoryName
                }).then((response) => {
                });
            }
        }

        if (checkCount) {
            $compareTool.show();
        } else {
            $compareTool.hide();
        }
    }

    $(document).on('click', '.compare-check, .js-comparebar-thumb-close', function () {
        checkboxState();
        if ($(this).attr('data-id')) {
            $("#compare_" + $(this).attr('data-id')).prop("checked", false);
        }
        compare();
    });
}
// endregion

$(function () {
    let $truncate = $('.js-truncate');
    if ($truncate.length > 0) {
        $truncate.each(function () {
            if ($(this).children().width() < $(this).width()) {
                $(this).removeClass('slide');
            } else {
                $(this).addClass('slide');
            }
        });
    }
});

$(document).on('change', '.js-customisation-select select, .js-customisation-select input', function () {
    let fields = $('.js-modal-form').serializeArray();

    let selected = [
        {location: '', image: ''},
        {location: '', image: ''},
        {location: '', image: ''},
        {location: '', image: ''},
    ];

    $.each(fields, function (index, field) {
        if (field.name.substring(0, 10) === 'customise[') {
            let found = field.name.match(/\w+\[(\d)]\[(image|location)]/)

            selected[parseInt(found[1], 10)][found[2]] = field.value;
        }
    })

    $.each(selected, function (index, details) {
        if (details.location !== '' && details.image !== '') {
            let url = $('.js-previews').attr('data-url') + '/' + details.location + '/' + details.image;
            $(`.js-preview-${index + 1}`).html(`<h4 class="text-center">Sample ${index + 1}</h4><img src="${url}" alt="" style="width: 100%" />`);
        } else {
            $(`.js-preview-${index + 1}`).html('');
        }
    });
})
